import { Editor } from "tinymce";
import { makeEditorModal } from "../Modal";
import { FeatureClass } from "../core/FeatureClass";
import { decodeMML, displayErrors, encodeMML, getData, getPoints, insertToEditor, pointsValid, setWindowNode, toJsonHtml } from "../core/Utils";
import { generateId, getModalInputId, insertData } from "../save/SaveUtils";
import { inputTransformation } from "../save/Interface";
import { openInsertImageModal } from "../core/Image";
import { openInsertFormulaModel } from "../core/Formulas";


export function addChoices(editor:Editor){
    const config = {
        featureName: "mcscchoices",
        id: "choices",
        icon: "choices",
        tooltip: 'Auswahlfeld erstellen',
        editor: editor,
        menuItems: [{
            name: 'edit-choices',
            icon: 'edit-block',
            text: 'Bearbeiten',
            action: (editor:Editor, command:string) => {
                const node = setWindowNode(editor);
                const data = getData(node);
               // console.log(data);
                const data2 = getChoiceData(node);
                console.log(data2);
                openModal(editor, command, data2);
            }
        }],
        buttonAction: (command:string) => {
            openModal(editor, command, {type: "mc", points:0, choices: []});
        },
        commandAction: (data:choices) => {
            insertChoice(data);
        }    
    }
    const feature = new FeatureClass(config);
    feature.addToEditor(editor);
}

function getChoiceData(node){ // hier kann man auch html parsen eigentlich
    const data = getData(node);
    const inputs = $(node).find(".choice-row");

    const choices = [];
    inputs.each((ind, obj) => {

        const item = $(obj).find(".choice-item");
        item.children(":first").removeAttr("data-mce-style").removeAttr("data-mce-src"); // remove  attributes that hinder height stuff
        const value = item.html();

        choices.push({
            answer: value,
            correct: data.choices[ind].correct,
            type: data.choices[ind].type
        })
    })

    data.choices = choices;
    return data;
}

function getChoicesData(inputs:JQuery){
    const choices = [];
    inputs.each((ind, obj) => {
        let checked = false;
        const checkbox = $(obj).find(".choice-check");
        if (checkbox.is(":checked")){
            checked = true;
        }
        const item = $(obj).find(".choice-item");
        const value = item.html();

        choices.push({
            answer: value,
            correct: checked,
            type: data.choices[ind].type
        })
    })
}




interface choiceItem {
    answer: string;
    correct: boolean;
    type?: string; // text, image, math
}

interface choices {
    id: number;
    type: string;
    points: number;
    choices: Array<choiceItem>;
}

export function transformMc(data:choices, ind:number, object:HTMLElement):inputTransformation{
    console.log(object);
    const html = displayCodeMc(data, ind, object);
    console.log(html);
    const totalPoints = data.points;
    let correct = mcResultInfo(data.choices, totalPoints, ind);
    correct = (correct.length == 0) ? '[]' : correct; // TODO: Watchout, this could cause an unwanted error that has been maybe unnecessarily fixed
    return {
        solution: {
            type: data.type,
            id: data.id,
            correct: correct,
            points: totalPoints,
            info: data.choices.length, 
        },
        html: html
    }
}

interface mcItem {
    value:string;
    correct:boolean;
    gewichtung:number;
}

function mcResultInfo(choices:Array<choiceItem>, points:number, ind:number):Array<number>{
    const correct = [];
    choices.forEach((item, ind) => {
        if (item.correct){
            correct.push(ind);
        }
    });
    return correct;
}
    // alt
function getMcInfo(choices:Array<choiceItem>, points:number, ind:number):Array<mcItem>{
    let countCorrect = 0;
    choices.forEach((item) => {
        if (item.correct){
            countCorrect += 1;
        }
    })
    const pointsPerCorrectAnswer = (countCorrect > 0) ? points / countCorrect : points;
    const items = [];
    choices.forEach((item) => {
        const gewichtung = (item.correct) ? pointsPerCorrectAnswer : -1 * pointsPerCorrectAnswer;
        items.push({
            value: item.answer,
            correct: item.correct,
            gewichtung: gewichtung
        })
    })
    return items;
}

function displayCodeMc(data:choices, ind:number, object:HTMLElement){
    let html = '<div data-type="' + data.type +'" data-id="'+data.id+'" class="mcsc_task d-inline-block input">'
    const rows = $(object).find(".choice-row") // bekommt alle optionen
    let i = 0;
    data.choices.forEach((item, index) => {
        const id = generateId(data.id);
        const optionHtml = $(rows[index]).find(".choice-item").html() // Eliminiert dieses ganze data gehabe

        html += '<div class="form-check d-flex align-items-center"><input class="form-check-input" type="checkbox" id="' + id + '_' + i + '" name="' + id + '" value="' + i + '">' +
        '<label class="form-check-label ms-2" for="' + id + '_' + i + '">' + optionHtml + '</label></div>';
        i+=1
    })
    html += '</div>';
    return html;
}

export function transformSc(data:choices, ind:number, object:HTMLElement):inputTransformation {
    const html = displayCodeSc(data, ind, object);
    const correctIndex = getCorrectIndex(data.choices);
    return {
        solution: {
            type: data.type,
            id: data.id,
            correct: correctIndex,
            points: data.points,
        },
        html: html,
    }

}

function getCorrectIndex(choices:Array<choiceItem>):number {
    let correct = 0;
    choices.forEach((item,ind) => {
        if (item.correct){
            correct = ind;
        }
    })
    return correct;
}

// so dumm -> aber altes klausursystem
function getScInfo(choices:Array<choiceItem>){
    const possible = {};
    const correct = {};
    choices.forEach((item, ind) => {
        possible[ind] = item.answer;
        if (item.correct){
            correct.index = ind;
            correct.answer = item.answer;
        }
    })
    return [possible, correct];
}

function displayCodeSc(data:choices, ind:number, object:HTMLElement){
    let html = '<div data-type="' + data.type + '" data-id="' + data.id + '" class="mcsc_task d-inline-block input">'
    const rows = $(object).find(".choice-row") // bekommt alle optionen
    data.choices.forEach((item, i) => {
        const name = generateId(data.id)

        const optionHtml = $(rows[i]).find(".choice-item").html() // Eliminiert dieses ganze data gehabe

        const id = name + '_' + i; // TODO: -> nachdenken, ob man die Answer als Value machen sollte, lieber den Index eigentlich!
        html += '<div class="form-check d-flex align-items-center"><input class="form-check-input me-2" type="radio" id=' + id + '_' + i + '" name="' + name + '" value="' + i + '">' +
        '<label class="form-check-label ms-2" for=' + id + '_' + i + '">' + optionHtml + '</label></div>';
    })
    html += '</div>';
    return html;
}

function insertChoice(data:choices){

    console.log(data);

    const html = transformChoiceForEditor(data);

    insertToEditor(html);
}

export function transformChoiceForEditor(data:choices){
    let insideHtml = '';
    if (data.type == "mc"){
        insideHtml += insertMultipleChoice(data);
    } else if (data.type == "sc"){
        insideHtml += insertSingleChoice(data);
    }

    // data.choices = removeUnnecessaryFromData(data.choices); // removes unnecessary stuff
    const json = toJsonHtml(data);
    let html = '<span id="choices" class="mceNonEditable d-inline-block input-item" data-json="' + json +'">';
    html += insideHtml;
    html += '</span>';
    return html;
}

function removeUnnecessaryFromData(choices:Array<choiceItem>):Array<choiceItem> {
    choices.forEach((choice, index) => {
        choices[index].answer = '';
    })
    return choices;
}

function insertMultipleChoice(data:choices){
    const html = renderMultipleChoiceEditor(data.choices);
    return html;
}

function insertSingleChoice(data:choices){
    return renderSingleChoiceEditor(data.choices);
}

function getType(modal:JQuery){
    return modal.find("#choice-type").val();
}

/**
 * Get Data From Modal for a. insert b. transform for Display
 * @param modal 
 * @returns 
 */

function getAnswer(item:JQuery, type:string){
    switch(type){
        case "text":
            return item.val()
        case "image":
            return item.find("img").prop('outerHTML');
        case "math":
           // let mathml = item.find("mjx-assistive-mml").html();
            //const mathml = item.find("math").prop('outerHTML')
            const mathml = decodeMML(item.attr('data-mathml'))
            console.log(mathml);
            return mathml
    }
}

function getDataFromModal(modal:JQuery):choices{
    const errors = [];
    const type = getType(modal);
    const points = getPoints(modal)
    if (!pointsValid(points)){
        errors.push("Die Eingabe braucht eine gültige Punktzahl");
    }
    const possibleAnswers = modal.find(".choice-row");
    const choices = [];
    possibleAnswers.each((ind, obj) => {
        const isCorrect = $(obj).find(".choice-check").is(":checked"); 
        const choiceItem = $(obj).find(".choice-item")
        const type = choiceItem.attr('data-type')
        const answer = getAnswer(choiceItem, type);
        if (answer != undefined && answer != ''){
            choices.push({
                answer: answer, // eigentlich unnötig
                correct: isCorrect,
                type: type,
            })
        } else {
            errors.push("Antwort fehlt");
        }
    });
    if (possibleAnswers.length < 2){
        errors.push("Man braucht mindestens 2 Antwortmöglichkeiten");
    }

    if (type == 'sc'){
        let problem = true;
        choices.forEach((choice) => {
            if (choice.correct){
                problem = false;
            }
        })
        if (problem){
            errors.push("Bei Single-Choice muss es mindestens eine richtige Antwort geben");
        }
    }

    const id = getModalInputId(modal);

    if (errors.length == 0){
        return {
            type: type,
            points: points,
            choices: choices,
            id: id,
        }
    } else {
        displayErrors(errors);
        return false;
    }
}

function getChoices():Array<choiceItem>{
    console.log("GETTING CHOICES");
    const modal = $("#create-choices")
    const possibleAnswers = modal.find(".choice-row");
    const choices = [];
    possibleAnswers.each((ind, obj) => {
        const isCorrect = $(obj).find(".choice-check").is(":checked"); 
        const choiceItem = $(obj).find(".choice-item")
        const type = choiceItem.attr('data-type');
        
        const answer = getAnswerFromItem(choiceItem, type);

        choices.push({
            answer: answer,
            correct: isCorrect,
            type: type
        })
    });
    return choices;
}

/**
 * Gets answer for display
 * @param item 
 * @param type 
 * @returns 
 */

function getAnswerFromItem(item:JQuery, type:string):string {
    switch(type){
        case "text":
            return item.val().toString();
        case "image":
            const img = item.find("img");
            console.log(img);
            img.removeAttr('data-mce-style')
            img.removeAttr('data-mce-src');
            console.log(img);
            return item.find("img").prop("outerHTML");
        case "math":
            console.log(item)
            console.log(item.find("math"))
            return decodeMML(item.attr('data-mathml'))
            return item.find("math").prop("outerHTML");
    }
}

function openModal(editor:Editor, command:string, choiceData:choices){
    const type = (choiceData.type !== undefined) ? choiceData.type : 'mc';
    const choices = (choiceData.choices !== undefined) ? choiceData.choices : [];
    let content = '<div class="choices-wrapper"><div class="row"><div class="col-8">' +
    '<p class="choice-info">' + 
    renderChoiceInfo(type) + 
    '</p></div><div class="col-4">' +
    renderChoiceSelect(type) +
    '</div>' +  
    '</div>' +
    '<div id="choices-wrapper">' +
    renderChoices(type, choices)
    '</div>';
    content += renderAddButton();
    content += '</div>';

    const settings = {
        submitBtn: {
            text: "Einfügen",
            class: "add-choices"
        },
        leftInput: {
            placeholder: "",
            text: "Punkte",
            type: "text",
            value: choiceData.points,
        },
        faq: 16,
        id: choiceData.id,
    }

    const modalId = "create-choices";
    const onclick = function(modal){
        const data = getDataFromModal(modal);
        if (data){
            return insertData(data, editor, command, modalId);
        }
    }

    const modal = makeEditorModal(modalId, 'Auswahlaufgabe erstellen', content, settings, onclick, addListeners);

    MathJax.typeset();
}

function addListeners(modal){
    
    modal.on("click", ".add-choice", function(){
        const type = getType(modal);
        addChoiceOption(type);
    });
    modal.on("click", ".remove-choice-item", function(){
        $(this).parent().remove();
    })
    modal.on("change", "#choice-type", function(){
        const type = $(this).val().toString();
        toggleChoice(type);
        MathJax.typeset();
    });
    modal.on("click", ".add-to-choice-field", function(){
        const type = $(this).attr('data-type');
        prepareChoiceInput(type, this);
    })
    modal.on("click", ".change-size", function(){
        changeSizeOfPicture(this);
    })
}

function changeSizeOfPicture(btn:HTMLElement){
    const prev = $(btn).parents(".input-group").find("img");
    const change = Number($(btn).attr('data-change'))
    const height = prev.height();
    const width = prev.width(); // get width
    const newWidth = width * (1+change)

    if (newWidth > 340){
        // increase 
        const modal = $(btn).parents(".modal-dialog")
        if (!modal.hasClass("modal-lg")){
            modal.addClass("modal-lg");
        }
    }
    if (newWidth > 580){
        errorToast("Bild kann nicht größer gemacht werden", "Achtung", 3500)
        return;
    }

    const newHeight = height * (1 + change)
    prev.css("height", newHeight + "px")
}


/**
 * What to do when the button to change Input Type is clicked
 * @param type 
 * @param btn 
 */

function prepareChoiceInput(type:string, btn:HTMLElement){
    const inputRow = $(btn).parents(".input-group")
    const inputItem = inputRow.find(".choice-item")
    if (type == "text"){
        inputRow.replaceWith(renderItem('', 'text'))
    } else if (type == "image"){
        // Open Image Modal with callback to replace inputItem
        openInsertImageModal(addImageAsChoiceItem ,{item: inputItem})
    } else if (type == "math"){
        console.log("Insert Formula")
        window["lastInputItem"] = inputItem; // dirty but have no time rn
        pexamath.load('')
        pexamath.afterExport = function(mathml:string){
            addMathAsChoiceItem(mathml, {})
        }
       // openInsertFormulaModel( addMathAsChoiceItem, {item: inputItem})
    }
}

function addMathAsChoiceItem(html:string, args:any){
    const item = window["lastInputItem"] // statt args.item
    const itemWrapper = item.parent('.input-group')

    itemWrapper.replaceWith(renderItem(html, 'math'))

    MathJax.typeset();
}


function addImageAsChoiceItem(url:string, args:any){
    const html = '<img class="choice-img resizable" height="75px" src="' + url + '">'

    const itemWrapper = args.item.parents('.input-group')
    itemWrapper.replaceWith(renderItem(html, 'image'))
}

function addImageSizeButtons(){
    let html = '<div class="btn-group-vertical ms-1">'
    html += '<button class="btn btn-sm btn-light-info text-info change-size" data-change="0.1"><i class="mdi mdi-plus"></i></button>'
    html += '<button class="btn btn-sm btn-light-info text-info change-size" data-change="-0.1"><i class="mdi mdi-minus"></i></button>'
    html += '</div>'
    return html;
}

function addChoiceOption(type:string){
    let html = '';
    if (type == "mc"){
        html = renderMultipleChoiceItem({answer: '', correct: false, type: 'text'});
    } else if (type == 'sc'){
        html = renderSingleChoiceItem({answer: '', correct: false, type: 'text'});
    }
    $("#choices-wrapper").append(html);
}

function toggleChoice(type:string){
    const data = getChoices();
    
    const html = renderChoices(type, data);
    $("#choices-wrapper").html(html);
}



function renderChoices(type='mc', items:Array<choiceItem>){
    if (items.length == 0){
        items = fillEmptyChoices();
    }
    let html = '';
    if (type == 'mc'){
        html += renderMultipleChoices(items);
    } else if (type == 'sc'){
        
        html +=  renderSingleChoices(items);
    }
    html += '</div>';
    return html;
}

export function renderAddButton(classString = 'add-choice', text='Möglichkeit hinzufügen'){
    const html = '<div class="d-flex justify-content-center align-items-center mb-2">' +
    '<button class="btn btn-light-success text-success ' + classString + '"><i class="fa fa-plus-circle"></i> ' + text + '</button>' + 
    '</div>';
    return html;
}

function fillEmptyChoices(){
    return [
        {
            answer: '',
            correct: false,
            type: 'text',
        },
        {
            answer: '',
            correct: false,
            type: 'text',
        },
        {
            answer: '',
            correct: false,
            type: 'text',
        }
    ];
}

function renderMultipleChoices(items:Array<choiceItem>){
    let html = '';
    items.forEach((item) => {
        html += renderMultipleChoiceItem(item);
    })
    return html;
}

function renderMultipleChoiceItem(item:choiceItem){
    const checked = (item.correct) ? ' checked' : '';
    const html = '<div class="d-flex align-items-center py-2 px-1 choice-row">' +
    '<input type="checkbox" style="height:26px;" class="form-control form-check-input choice-check"' + checked + '>' +
 //   '<div class="input-group">' +
        renderItem(item.answer, item.type) + 
 //   '</div>' + 
    '<button class="p-2 ms-2 d-inline-flex btn btn-light-danger text-danger remove-choice-item" type="button"><i class="fa fa-trash"></i></button>' +
    '</div>';
    return html;
}

function renderSingleChoices(items:Array<choiceItem>){
    let html = '';
    items.forEach((item) => {
        html += renderSingleChoiceItem(item);
    })
    return html;
}

function renderSingleChoiceItem(item:choiceItem){
    const checked = (item.correct) ? ' checked' : '';
    const html = '<div class="d-flex align-items-center py-2 px-1 choice-row">' +
    '<input type="radio" style="height:26px;" name="sc" class="form-control form-check-input choice-check"' + checked + '>' +
 //   '<div class="input-group">' +
        renderItem(item.answer, item.type) + 
 //   '</div>' + 
    '<button class="p-2 ms-2 d-inline-flex btn btn-light-danger text-danger remove-choice-item" type="button"><i class="fa fa-trash"></i></button>' +
    '</div>';
    return html;
}

function renderItem(answer:string, currentType:string){
    // let types = ['image', 'math', 'text'];
    // let icons = ['mdi mdi-image', 'mdi mdi-sigma', 'mdi mdi-format-text']
    const types = ['math', 'image', 'text'];
    const icons = ['mdi mdi-sigma', 'mdi mdi-image', 'mdi mdi-format-text']
    const tooltips = ['Formel einfügen', 'Bild einfügen', 'Textfeld einfügen']
    // Do start
    let s = '<div class="input-group'
    if (currentType == "image" || currentType == "math"){
        s += ' align-items-center'
    }
    s += '">'

    // Render Answer
    s += renderAnswer(answer, currentType);
    // Render Buttons
    s += renderItemTypeChangeButton(currentType, types, icons, tooltips);

    s += '</div>'
    
    return s;

}

function renderAnswer(answer:string, type:string):string {
    let s = '';
    if (type == 'text'){
        s += '<input type="text" class="ms-2 choice-item form-control form-control-lg" data-type="' + type + '" value="' + answer + '">'
    } else if (type == 'image'){
        const buttons = addImageSizeButtons();
        s += '<div class="ms-2 choice-item" data-type="' + type + '">' + answer + buttons + '</div>'
    } else if (type == 'math'){

        // if ($(answer).attr('data-mathml')){
        //     const mml = $(answer).attr('data-mathml')
        //     answer = decodeMML(mml)
        // }

        s += '<div class="ms-2 choice-item" data-type="' + type + '" data-mathml="' + encodeMML(answer) + '">' + answer + '</div>'
    }
    return s;
}

function renderItemTypeChangeButton(currentType:string, types:Array<string>, icons:Array<string>, tooltips:Array<string>):string {
    let s = (currentType == "text") ? '' : '<div class="ms-auto">';
    types.forEach((item, index) => {
        if (item != currentType){
            s += '<button class="btn btn-light-info text-info add-to-choice-field" data-type="' + types[index] + '" title="' + tooltips[index] + '"><i class="' + icons[index] + '"></i></button>'
        }
    })
    s += (currentType == "text") ? '' : '</div>'
    return s;
}

function renderMultipleChoiceEditor(items:Array<choiceItem>){
    let html = '';
    items.forEach((item) => {
        html += renderMultipleChoiceItemEditor(item);
    });
    return html;
}

function renderSingleChoiceEditor(items:Array<choiceItem>){
    let html = '';
    items.forEach((item) => {
        html += renderSingleChoiceItemEditor(item);
    });
    return html;
}

function renderMultipleChoiceItemEditor(item:choiceItem){
    const checked = (item.correct) ? ' checked' : '';
    const html = '<span class="d-flex align-items-center py-2 px-1 choice-row">' +
    '<input type="checkbox" style="height:26px;" class="form-control form-check-input choice-check"' + checked + ' disabled>' +
    '' +
    '<span class="ms-2 choice-item form-control">' + item.answer + '</span>' + 
    '</span>';
    return html;
}

function renderSingleChoiceItemEditor(item:choiceItem){
    const checked = (item.correct) ? ' checked' : '';
    const html = '<span class="d-flex align-items-center py-2 px-1 choice-row">' +
    '<input type="radio" style="height:26px;" name="sc" class="form-control form-check-input choice-check' + checked + '" disabled>' +
    '' +
  //  '<input type="text" class="ms-2 choice-item form-control" disabled value="' + item.answer + '">' + 
  '<span class="ms-2 choice-item form-control">' + item.answer + '</span>' + 
    '</span>';
    return html;
}


function renderChoiceInfo(type='mc'){
    if (type == 'mc'){
        return 'Du kannst eine Eingabe mit keinen bis mehreren richtigen Antworten erstellen';
    } else if (type == 'sc'){
        return 'Du kannst eine Eingabe mit einer richtigen Antwort erstellen';
    }
}

function renderChoiceSelect(type='mc'){
    let html = '<select id="choice-type" class="form-control form-select">'
    if (type == 'mc'){
        html += '<option value="mc" selected>Multiple Choice</option><option value="sc">Single Choice</option>'
    } else if (type == 'sc'){
        html += '<option value="mc">Multiple Choice</option><option value="sc" selected>Single Choice</option>'
    }
    html += '</select>';
    return html;
}